import { render, staticRenderFns } from "./dybmb.vue?vue&type=template&id=23db9eec&"
import script from "./dybmb.vue?vue&type=script&lang=js&"
export * from "./dybmb.vue?vue&type=script&lang=js&"
import style0 from "./dybmb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports